import Vue from "vue";
import Router from "vue-router";
import Import from './components/import.vue';
import Register from './components/Register.vue';
import Login from './components/Login.vue';
import managemenus from './components/managemenus.vue';
import users from './components/users.vue';
import Menus from './components/Menus.vue';
import Instructor from './components/Instructor.vue';
import ProctorGenerate from './components/ProctorGenerate.vue';
import firstpdf from './components/firstpdf.vue';

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/FirstPDF",
      alias: "/FirstPDF",
      name: "FirstPDF",
      component: firstpdf
    },
    {
      path: "/ProctorGenerate",
      alias: "/ProctorGenerate",
      name: "ProctorGenerate",
      component: ProctorGenerate
    },
    {
      path: "/import",
      alias: "/import",
      name: "import",
      component: Import
    },
    {
      path: "/register",
      alias: "/register",
      name: "register",
      component: Register
    },
    {
      path: "/",
      alias: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/menu",
      alias: "/menu",
      name: "menu",
      component: Menus
    },
    {
      path: "/menus",
      alias: "/menus",
      name: "menus",
      component: managemenus
    },
    {
      path: "/users",
      alias: "/users",
      name: "users",
      component: users
    },
    {
      path: "/menu",
      alias: "/menu",
      name: "menu",
      component: Menus
    },{
      path: "/instructor",
      alias: "/instructor",
      name: "instructor",
      component: Instructor
    },
  ]
});


router.beforeEach((to, from, next) => {
  var page = to.path.split("/")
  // console.log(page[1]);
  var activateemail = ''
  if (page[1] == 'activateemail') {
    activateemail = to.path
    // console.log(activateemail);
  }
  const publicPages = ['/register','/login',activateemail];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('userexam');
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) { 
      next('/login');
    // next();
  } else {
    next();
  }

});

export default router;
